import Vue from 'vue'
import VueRouter from 'vue-router'
import {HTTP} from './http-common'
const OrderAdmin = () => import('./orders/OrderAdmin')
const CuratedGeoAdmin = () => import('./curated_geo/CuratedGeoAdmin')
const RewardsAdmin = () => import('./rewards/RewardsAdmin')
const TicketsUiAdmin = () => import('./tickets-ui/TicketsUiAdmin')
const LogoAdmin = () => import('./LogoAdmin')
const ModuleEditorAdmin = () => import('./module-editor/ModuleEditorAdmin')
const CustomPageAdmin = () => import('./custom-page/CustomPageAdmin')
const CustomListsAdmin = () => import('./custom-lists/CustomListsAdmin')
const ThemeBasicUi = () => import('./theme/ThemeBasicUi')
const ThemeAdvancedCss = () => import('./theme/ThemeAdvancedCss')
const ThemeAdvancedJs = () => import('./theme/ThemeAdvancedJs')
const LiteSitesAdmin = () => import('./lite-admin/LiteSitesAdmin')
// const LiteUrlStructureAdmin = () => import("./url-structure/LiteUrlStructureAdmin")
const TermsAdmin = () => import("./TermsAdmin")
const SocialMediaAdmin = () => import("./social-media/SocialMediaAdmin")
const ServiceFeesAdmin = () => import("./service-fees/ServiceFeesAdmin")
const ShippingMethodsAdmin = () => import("./shipping-methods/ShippingMethodsAdmin")
const TicketMarkupsAdmin = () => import("./ticket-markups/TicketMarkupsAdmin")
const SpcCartAdmin = () => import("./spc-cart/SpcCartAdmin")
const CouponsAdmin = () => import("./coupons/CouponsAdmin")
const GiftcardsAdmin = () => import("./giftcards/GiftcardsAdmin")
const CurrencyAdmin = () => import("./currency/CurrencyAdmin")
const AdvancedTicketRulesAdmin = () => import("./advanced-ticket-rules/AdvancedTicketRulesAdmin")
const FeedAFeedAdmin = () => import("./feed-a-feed/FeedAFeedAdmin")
const RobotsAdmin = () => import("./robots/RobotsAdmin")
const AffiliatesAdmin = () => import("./affiliates/AffiliatesAdmin")
const EditAffiliatesAdmin = () => import("./affiliates/EditAffiliatesAdmin")
const SendgridEmailsAdmin = () => import("./email/SendgridEmailsAdmin")
const SplitTenderAdmin = () => import("./split-tender/SplitTenderAdmin")
const SnappyAccountingAdmin = () => import("./split-tender/custom/snappy/SnappyAccountingAdmin")

import VueNotifications from 'vue-notifications'
import iziToast from 'izitoast'
import 'izitoast/dist/css/iziToast.min.css'
import 'document-register-element'

function toast({title, message, type, timeout, cb, cbClosed}) {
    if (type === VueNotifications.types.warn) type = 'warning';
    return iziToast[type]({
        title: title,
        message: message,
        timeout: timeout,
        onClosed: cbClosed
    })
}

const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
};

Vue.use(VueNotifications, options);

Vue.use(VueRouter);
const routes = [
    { path: '/advanced_ticket_rules', component: AdvancedTicketRulesAdmin },
    { path: '/configuration/logos', component: LogoAdmin },
    { path: '/curated_geo', component: CuratedGeoAdmin },
    { path: '/editor', component: ModuleEditorAdmin },
    { path: '/file_adder', component: CustomPageAdmin },
    { path: '/lists/:ListID?', name: "lists", component: CustomListsAdmin },
    { path: '/rewards', component: RewardsAdmin },
    { path: '/theme/basic', component: ThemeBasicUi },
    { path: '/theme/css', component: ThemeAdvancedCss },
    { path: '/theme/js', component: ThemeAdvancedJs },
    { path: '/tickets_ui', component: TicketsUiAdmin },
    { path: '/atbs', component: LiteSitesAdmin },
    // { path: '/url_structure_lite', component: LiteUrlStructureAdmin },
    { path: '/terms', component: TermsAdmin },
    { path: '/social_media', component: SocialMediaAdmin },
    { path: '/service_fees', component: ServiceFeesAdmin },
    { path: '/shipping_method', component: ShippingMethodsAdmin },
    { path: '/ticket_markups', component: TicketMarkupsAdmin },
    { path: '/spc_cart', component: SpcCartAdmin },
    { path: '/coupons', component: CouponsAdmin },
    { path: '/giftcards', component: GiftcardsAdmin },
    { path: '/currency', component: CurrencyAdmin },
    { path: '/orders', component: OrderAdmin },
    { path: '/feed_a_feed', component: FeedAFeedAdmin },
    { path: '/robots', component: RobotsAdmin },
    { path: '/affiliates', component: AffiliatesAdmin, name: 'affiliates' },
    { path: '/affiliates/:id', component: EditAffiliatesAdmin },
    { path: '/sendgrid_emails', component: SendgridEmailsAdmin },
    { path: '/split_tender', component: SplitTenderAdmin },
    { path: '/snappy_accounting', component: SnappyAccountingAdmin },
];
const router = new VueRouter({
    routes,
    base: atbsPaths.basePath+'/admin/',
    mode: 'history'
});

const IE11RouterFix = {
    methods: {
        hashChangeHandler: function() { this.$router.push(window.location.hash.substring(1, window.location.hash.length)); },
        isIE11: function() { return !!window.MSInputMethodContext && !!document.documentMode; }
    },
    mounted: function() { if ( this.isIE11() ) { window.addEventListener('hashchange', this.hashChangeHandler); } },
    destroyed: function() { if ( this.isIE11() ) { window.removeEventListener('hashchange', this.hashChangeHandler); } }
};

Vue.prototype.$http = HTTP;
let vm = new Vue({
    el: '#app',
    router: router,
    components: { OrderAdmin },
    mixins: [IE11RouterFix],
    notifications: {
        showSuccessMsg: {
            type: VueNotifications.types.success,
            title: 'Success',
            message: 'Changes have been saved',
            cbClosed: null
        },
        showInfoMsg: {
            type: VueNotifications.types.info,
            title: 'Info',
            message: 'Info message',
            cbClosed: null
        },
        showWarnMsg: {
            type: VueNotifications.types.warn,
            title: 'Warning',
            message: 'A warning was occurred',
            cbClosed: null
        },
        showErrorMsg: {
            type: VueNotifications.types.error,
            title: 'Error',
            message: 'An error occurred',
            cbClosed: null
        }
    }
});
Vue.prototype.$successMsg = vm.showSuccessMsg
Vue.prototype.$infoMsg = vm.showInfoMsg
Vue.prototype.$warnMsg = vm.showWarnMsg
Vue.prototype.$errorMsg = vm.showErrorMsg
